import { render, staticRenderFns } from "./ProgrammeSelectTable.vue?vue&type=template&id=3f1c254e&"
import script from "./ProgrammeSelectTable.vue?vue&type=script&lang=js&"
export * from "./ProgrammeSelectTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports